const MOBILE_DEVICE = "mobile";
const TABLET_DEVICE = "tablet";
const DESKTOP_DEVICE = "desktop";
const IOS_DEVICE = "IOS";
const ANDROID_DEVICE = "ANDROID";
const BOT = /bot|googlebot|crawler|spider|robot|crawling/i;
const GOOGLEBOT = /googlebot|Googlebot/i;

module.exports = {
  MOBILE_DEVICE,
  TABLET_DEVICE,
  DESKTOP_DEVICE,
  IOS_DEVICE,
  ANDROID_DEVICE,
  BOT,
  GOOGLEBOT,
};
